export default "__VITE_ASSET__DeOFDzjZ__"